<template>
    <div class="task-types">
        <b-card :title="$translate('task_types')" class="inner-page p-3 form-sample">
            <b-card-body>
                <b-overlay :show="updating" rounded="sm">
                    <b-form class="p-0 pt-2">
                        <div class="d-flex my-2">
                            <div class="form-check me-2">
                                <label class="form-check-label">
                                    <input type="checkbox" id="input-isTaskType" v-model="isTaskType" />
                                    <i class="input-helper"></i>
                                </label>
                            </div>

                            <label for="input-isTaskType"><strong>{{ $translate('task_types') }}</strong></label>

                        </div>
                        <b-col v-if="isTaskType" class="mt-3 dd">
                            <label for="input-measureable" class="mb-3"><strong>{{ $translate('measureable_item_types')
                            }}</strong></label>
                            <multiselect id="input-measureable" :placeholder="$translate('select_option')"
                                :deselectLabel="deselectLabel" :selectedLabel="selectedLabel" :selectLabel="selectLabel"
                                v-model="measurableTypesOptions" :multiple="true" :options="items" label="name" track-by="id"
                                :close-on-select="false">
                            </multiselect>
                        </b-col>
                        <b-col v-if="isTaskType" class="mt-3 dd">
                            <label for="input-checkable" class="mb-3"><strong>{{ $translate('checkable_item_types')
                            }}</strong></label>
                            <multiselect id="input-checkable" :placeholder="$translate('select_option')" v-model="checkableTypesOptions" :multiple="true" :options="items"
                                label="name" track-by="id" :close-on-select="false">
                            </multiselect>
                        </b-col>
                        <b-col v-if="isTaskType" class="mt-3">
                            <label for="input-productCaption" class="mb-3"><strong>{{ $translate('product_caption')
                            }}</strong></label>
                            <b-form-input id="input-productCaption" v-model="formData.productCaption">
                            </b-form-input>
                        </b-col>
                        <b-col v-if="isTaskType" class="mt-3">
                            <label for="input-measurableCaption" class="mb-3"><strong>{{ $translate('measureable_caption')
                            }}</strong></label>
                            <b-form-input id="input-measurableCaption" v-model="formData.measurableCaption">
                            </b-form-input>
                        </b-col>
                        <b-col v-if="isTaskType" class="mt-3">
                            <label for="input-checkableCaption" class="mb-3"><strong>{{ $translate('checkable_caption')
                            }}</strong></label>
                            <b-form-input id="input-checkableCaption" v-model="formData.checkableCaption">
                            </b-form-input>
                        </b-col>
                        <b-col class="mt-4 text-center">
                            <button variant="primary" @click="updateTypes" v-if="hasPermissionUpdate" size="sm"
                                class="btn btn btn-info btn-fw me-2 btn-primary">
                                <b-spinner small v-if="updating" :label="$translate('loading')"></b-spinner>
                                <span v-else>{{ $updateLabel() }}</span>
                            </button>
                        </b-col>
                    </b-form>
                </b-overlay>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'taskTypes',
    mixins: [popupMixins, permissionsMixins],
    components: { Multiselect },
    data: () => ({

        formData: {
            isTaskType: 0,
            measurableTypes: [],
            checkableTypes: [],
            productCaption: null,
            measurableCaption: null,
            checkableCaption: null,
        },
        updating: false,
    }),

    filters: {
        filterOptions(items) {
            return items.map(({ id: value, name: text }) => ({ value, text }))
        },
    },

    computed: {
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },

        componentName() { return this.$translate('task_type') },
        //checkableTypes
        isTaskType: {
            get() {
                return !!this.formData.isTaskType
            },
            set(value) {
                this.$set(this.formData, 'isTaskType', value ? 1 : 0)
            },
        },

        checkableTypesOptions: {
            get() {
                const {
                    items,
                    formData: { checkableTypes },
                } = this
                return checkableTypes.map(id =>
                    items.find(item => item.id == id)
                ).filter(item => !!item)
            },
            set(selectedItems) {
                this.$set(
                    this.formData,
                    'checkableTypes',
                    selectedItems.map(x => x.id)
                )
            },
        },

        measurableTypesOptions: {
            get() {
                const {
                    items,
                    formData: { measurableTypes },
                } = this
                return measurableTypes.map(id =>
                    items.find(item => item.id == id)
                ).filter(item => !!item)
            },
            set(selectedItems) {
                this.$set(
                    this.formData,
                    'measurableTypes',
                    selectedItems.map(x => x.id)
                )
            },
        },

        taskTypeValue() {
            const taskTypeValue = this.$store.getters['company/taskTypeValue']
            console.log('computed taskTypeValue', taskTypeValue)
            return taskTypeValue
        },

        taskTypeKey() {
            return this.$store.state.company.settingKeys.taskTypeKey
        },

        items() {
            const items = this.$store.state.itemType.items
            console.log('items', items)
            return items
                .filter(x => x.is_task)
                .map(x => {
                    x.is_task = !!x.is_task
                    x.is_order_item = !!x.is_order_item
                    x.is_discount = !!x.is_discount
                    return x
                })
        },
    },

    watch: {
        taskTypeValue: {
            handler: function (val) {
                console.log('watch taskTypeValue', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },

    created() {
        this.$store.dispatch('itemType/fetchAll')
    },

    async mounted() {
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.taskTypeKey
        )
        this.$nextTick(() => {
            this.updateModel(this.taskTypeValue)
        })
    },

    methods: {
        updateModel(taskTypeValue) {
            const value = { ...(taskTypeValue || {}) }
            this.$set(this.formData, 'isTaskType', value.isTaskType || 0)
            this.$set(
                this.formData,
                'measurableTypes',
                value.measurableTypes || []
            )
            this.$set(
                this.formData,
                'checkableTypes',
                value.checkableTypes || []
            )
            this.$set(
                this.formData,
                'productCaption',
                value.productCaption || null
            )
            this.$set(
                this.formData,
                'measurableCaption',
                value.measurableCaption || null
            )
            this.$set(
                this.formData,
                'checkableCaption',
                value.checkableCaption || null
            )
        },
        async updateTypes() {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.formData)
                const bool_value = false
                const value = { ...(this.formData || {}) }

                if (value.productCaption && !this.$escapeSpecialCharRule.test(value.productCaption)) {
                    throw Error(this.$translate('product_caption_regex_alert'))
                }
                if (value.measurableCaption && !this.$escapeSpecialCharRule.test(value.measurableCaption)) {
                    throw Error(this.$translate('measurable_caption_regex_alert'))
                }
                if (value.checkableCaption && !this.$escapeSpecialCharRule.test(value.checkableCaption)) {
                    throw Error(this.$translate('checkable_caption_regex_alert'))
                }
                await this.$store.dispatch('company/updateConfiguration', {
                    key: this.taskTypeKey,
                    text_value,
                    bool_value,
                })

                this.genericToast(
                    this.componentName,
                    this.$translate('updated'),
                    'success',
                    `${this.componentName} ${this.$translate('update_alert')}`
                )
            } catch (error) {
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
